export default function renameKeys(obj, newKeys = { heavy_mobile_equipment: 'Assets' }) {
  const keyValues = Object.keys(obj).map(key => {
    const newKey = newKeys[key] || key;
    return { [newKey]: obj[key] };
  });
  return Object.assign({}, ...keyValues);
}
